export const fadeInBackground = {
  '0%': {
    opacity: 0
  },

  '50%': {
    opacity: 1
  }
};

export const checkmarkPath = {
  '0%, 50%': {
    strokeDashoffset: '22.91026'
  },

  '50%': {
    animationTimingFunction: 'cubic-bezier(0, 0, .2, .1)'
  },

  '100%': {
    strokeDashoffset: 0
  }
};

export const indeterminatePath = {
  '0%': {
    width: 0
  },
  '100%': {
    width: '100%'
  }
};

export const animateIndeterminate = {
  from: {
    animationTimingFunction: 'cubic-bezier(0.14, 0, 0, 1)',
    opacity: 0,
    transform: 'rotate(45deg)'
  },

  to: {
    opacity: 1,
    transform: 'rotate(360deg)'
  }
};

export const checkedStyle = {
  '@keyframes fadein-background': fadeInBackground,
  WebkitAnimation: '180ms linear 0s fadein-background',
  animation: '180ms linear 0s fadein-background',
  backgroundColor: 'var(--primary-color)',
  borderColor: 'var(--primary-color)',
  color: '#fff'
};
